import { render, staticRenderFns } from "./Nuevo-cheque-tercero.vue?vue&type=template&id=0bd95308"
import script from "./Nuevo-cheque-tercero.vue?vue&type=script&lang=js"
export * from "./Nuevo-cheque-tercero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports